// Lib
import { FC, useEffect, useState } from "react";
// Api
import { useGetLogsQuery } from "rtkQuery/query/logsAPI";
// Hooks
import { useNotification, useViewport } from "hooks";
// Constants
import { rtkQueryParams } from "consts";
// Utils
import { errorHandler } from "utils/errorHandler";
// Icons
import { DescriptionBlackIcon } from "icons";
// Components
import { Table } from "components";
// Styled
import { FlexContainer, PageWrapper } from "styled/Box";
import { Typography } from "styled/Typography";

import { columns } from "./config";

export const Logs: FC = () => {
  const { isDesktop } = useViewport();

  const { openNotification } = useNotification();

  const [cursor, setCursor] = useState<string | null>(null);

  const {
    data: logsData,
    isFetching,
    error: logsError,
  } = useGetLogsQuery(
    {
      query: {
        limit: 30,
        cursor,
      },
    },
    rtkQueryParams,
  );

  useEffect(() => {
    if (logsError) {
      errorHandler({ error: logsError, openNotification });
    }
  }, [logsError]);

  const handleFetchNextPage = () => {
    if (logsData?.lastEvaluatedKey) {
      setCursor(logsData.lastEvaluatedKey);
    }
  };

  return (
    <PageWrapper $fullwidth $column>
      <FlexContainer
        $fullwidth
        $column
        $grow={1}
        $padding={isDesktop && "0 0 32px"}
      >
        <FlexContainer
          $padding="0 0 24px"
          $align="center"
          $justify="space-between"
        >
          <Typography.H1>Logs</Typography.H1>
        </FlexContainer>

        <Table
          isLoading={isFetching}
          dataSource={logsData?.items || []}
          columns={columns}
          empty={{
            icon: DescriptionBlackIcon,
            title: "No Logs to show.",
          }}
          infiniteScroll={{
            canFetchNextPage: !!logsData?.hasMore,
            fetchNextPage: handleFetchNextPage,
          }}
        />
      </FlexContainer>
    </PageWrapper>
  );
};
